
//export const API_ROOT = window.PAGE_DATA.commonData.rootPath
// 测试的时候使用的IP,正式环境在做替换
export const API_ROOT = window.PAGE_DATA.commonData.basePath
// news 汇市阅读
export const API_NEWS = window.PAGE_DATA.commonData.newsPath
// ucenter 个人中心
export const API_UCENTER = window.PAGE_DATA.commonData.ucenterPath

// information 资讯
export const API_INFORMATION = window.PAGE_DATA.commonData.basePath
export const API_BORKER = window.PAGE_DATA.commonData.basePath
export const API_HOMEPAGE = window.PAGE_DATA.commonData.basePath
export const API_NEWSSO = window.PAGE_DATA.commonData.rootPath

// 沙龙
export const API_SALON = window.PAGE_DATA.commonData.salonPath
// 培训
export const API_TRAIN = window.PAGE_DATA.commonData.trainPath



// WEBPACK FOOTER //
// ./src/service/common/api/config.js